<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<div class="container-fluid p-0 my-3" *ngIf="data && !loading; else loadingTemplate">
  <button class="v4-btn-every my-3" *ngIf="goBackBtn" (click)="goBack()"><i class="pi pi-arrow-right m-l-2"></i>{{'Back' | translator}}</button>
  <app-no-data *ngIf="data.length <= 0"></app-no-data>
  <p-table
    *ngIf="data.length > 0"
    [value]="data"
    dataKey="_id"
    [tableStyle]="{ 'min-width': '90rem' }"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>
          <div class="d-flex gap-2">
            <p-checkbox type="checkbox" name="select-all" [binary]="true"
                [(ngModel)]="selectAllUsersFlag" (ngModelChange)="toggleSelectAll()"
                pTooltip="{{ 'Select All' | translator}}" tooltipPosition="top"
                />
            <!-- <label for="selectAllCheckbox" class="p-20" style="cursor: pointer">
              {{ "Select All" | translator}}
            </label> -->
          </div>
        </th>
        <th *ngFor="let column of columns">
          
            {{ column | translator }}
          <ng-container *ngIf="column == 'Score / Total Marks'">
            {{' من ' +  TotalScore }}
          </ng-container>
        </th>
        <th *ngIf="action > 0">{{ "Actions" | translator }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-attendee>
      <tr *ngIf="attendee.user; else exterTemplate">
        <td>
          <p-checkbox 
              type="checkbox" 
              [binary]="true"
              [ngModel]="isUserSelected(attendee)" 
              (ngModelChange)="AddUserEmailToList(attendee)">
            </p-checkbox>
        </td>
        <td *ngFor="let column of columns">
          <ng-container
            *ngIf="
              column == 'Score / Total Marks' &&
                !attendee?.isScoreMarked &&
                hasOpenEndedQuestions(attendee?.questions);
              else scoreColumn
            "
          >
            <p-button
              (click)="attendee.questions ? ShowQuestions(attendee) : null"
              icon="pi pi-check 111"
            ></p-button>
          </ng-container>
          <ng-template #scoreColumn>
            <ng-container
              *ngIf="
                (column == 'Percentage' || column == 'Result') &&
                  !attendee?.isScoreMarked &&
                  hasOpenEndedQuestions(attendee?.questions);
                else scoreColumn2
              "
            >
            </ng-container>
            <ng-template #scoreColumn2>
              {{ getColumnValue(attendee, column, 1) | translator }}
            </ng-template>
          </ng-template>
        </td>
        <td *ngIf="action == 1">
          <button
            class="v4-btn-every p7"
            [disabled]="!(attendee.markType == 'Pending')"
            (click)="confirmMark(attendee?.email)"
            [pTooltip]="'revision'| translator"
          >
            <i class="pi pi-check"></i>
          </button>
        </td>
        <td *ngIf="action == 2">
          <p-button
            (click)="attendee.questions ? ShowQuestions(attendee) : null"
            icon="pi pi-edit"
            [pTooltip]="'Edit Results'| translator"
          ></p-button>
          <p-button
            (click)="attendee.questions ? AllowRedo(attendee, 1) : null"
            icon="pi pi-refresh"
            [pTooltip]="'Allow Redo'| translator"
          ></p-button>
          <p-button
            *ngIf="from == 'assessment'"
            (click)="attendee.user.email ? downlaodCertificate(attendee.user.email) : null"
            icon="pi pi-file-pdf"
            [pTooltip]="'Download Certificate'| translator"
          ></p-button>
        </td>
      </tr>
      <ng-template #exterTemplate>
        <tr>
          <td>
            <p-checkbox 
              type="checkbox" 
              [binary]="true"
              [ngModel]="isUserSelected(attendee)" 
              (ngModelChange)="AddUserEmailToList(attendee)">
            </p-checkbox>
          </td>
          <td *ngFor="let column of columns">
            <ng-container
              *ngIf="
                column == 'Score / Total Marks' &&
                  !attendee?.isScoreMarked &&
                  hasOpenEndedQuestions(attendee?.questions);
                else scoreColumn
              "
            >
              <p-button
                (click)="attendee.questions ? ShowQuestions(attendee) : null"
                icon="pi pi-check 222"
              ></p-button>
            </ng-container>
            <ng-template #scoreColumn>
              <ng-container
                *ngIf="
                  (column == 'Percentage' || column == 'Result') &&
                    !attendee?.isScoreMarked &&
                    hasOpenEndedQuestions(attendee?.questions);
                  else scoreColumn2
                "
              >
                -
              </ng-container>
              <ng-template #scoreColumn2>
                {{ getColumnValue(attendee, column, 2) | translator }}
              </ng-template>
            </ng-template>
          </td>
          <td *ngIf="action == 1">
            <button
              class="v4-btn-every p7"
              [disabled]="!(attendee.markType == 'Pending')"
              (click)="confirmMark(attendee?.email)"
              [pTooltip]="'revision'| translator"
            >
              <i class="pi pi-check"></i>
            </button>
          </td>
          <td *ngIf="action == 2">
            <div class="d-flex gap-2">
            <button class="tabel-circle-btn"
              (click)="attendee.questions ? ShowQuestions(attendee) : null"
              [pTooltip]="'Edit Results'| translator"
            ><i class="{{from == 'assessment' ? 'pi pi-pencil' : 'pi pi-eye'}}"></i> </button>
            <button class="tabel-circle-btn"
              (click)="attendee.questions ? AllowRedo(attendee, 2) : null"
              [pTooltip]="'Allow Redo'| translator"
            ><i class="pi pi-refresh"></i></button>
            <button class="tabel-circle-btn"
            *ngIf="from == 'assessment'"
              (click)="attendee.email ? downlaodCertificate(attendee.email) : null"
              [pTooltip]="'Download Certificate'| translator"
            ><i class="pi pi-file-pdf"></i></button>
          </div>
          </td>
        </tr>
      </ng-template>
    </ng-template>
  </p-table>
</div>
<!-- <hr /> -->
<div
  *ngIf="!loading && pagging && totalCount > 10"
  class="d-flex align-items-center justify-content-center gap-1 mb-2"
>
  <p-paginator
    [hidden]="totalCount <= 10"
    (onPageChange)="onPageChange($event)"
    [first]="first"
    [rows]="rows"
    [totalRecords]="totalCount"
    [rowsPerPageOptions]="[10, 20, 30]"
  ></p-paginator>
</div>
<ng-template #loadingTemplate>
  <div style="width: 100%; height: 70vh" class="d-center">
    <p-progressBar></p-progressBar>
  </div>
</ng-template>
<p-dialog
  [header]="'Questions' | translator"
  [maximizable]="true"
  [(visible)]="openQuestionModal"
  [style]="{ width: '95vw', maxWidth: '1000px' }"
>
  <p-tabView
    [activeIndex]="0"
  >
    <p-tabPanel header="{{ 'All Questions' | translator }}">
      <div
        class="{{
          from != 'assessment'
            ? null
            : question.score === 0 && question.meta.marks > 0
            ? 'v4-bg-red'
            : 'v4-bg-green'
        }}"
        *ngFor="let question of questionsToShow; let i = index"
      >
        <ng-container *ngIf="from == 'assessment'">
          <div class="" *ngIf="!scoreHideQuestions.includes(question.type)">
            <div class="d-flex column label-score">
              <span class="ans-color mt-4">{{
                "Score" | translator
              }}</span>
            </div>
            <p-inputNumber
              inputId="integeronly"
              class="input-number-field"
              [placeholder]="'Score' | translator"
              [inputStyle]="{
                                          'background-color': 'transparent',
                                          'border': question.score === 0 && question.meta.marks > 0 ? 'solid 2px red' : 'solid 3px green',
                                          'border-radius': '8px',
                                          'width': '100%',
                                          'margin-right': '40px',
                                          'margin-top': '2px',
                                      }"
              [(ngModel)]="question.score"
              [min]="0" [max]="question.meta.marks"
            />
          </div>
        </ng-container>
        <div
          *ngIf="
            !scoreHideQuestions.includes(question.type) &&
            question.meta.feedback != undefined &&
            question.meta.feedback.trim() != ''
          "
          class="d-flex column label-score mb-2"
        >
          <span class="ans-color">{{
            "Feedback" | translator
          }}</span>
        </div>
        <p-editor
          [readonly]="true"
          *ngIf="
            !scoreHideQuestions.includes(question.type) &&
            question.meta.feedback != undefined &&
            question.meta.feedback.trim() != ''
          "
          [(ngModel)]="question.meta.feedback"
          class="w-100"
          [style]="{ height: '100px' }"
        ></p-editor>
        <div class="d-flex column label-score">
          <span class="ans-color">
            {{ "Correct Answer" | translator }} : {{ getCorrect(question)}}
          </span
          >
        </div>
        <app-question-template
          [disabled]="true"
          [question]="question"
          #questionDiv
        ></app-question-template>
      </div>
    </p-tabPanel>
    <p-tabPanel
      header="{{ 'Open Ended Questions' | translator }}"
      *ngIf="from == 'assessment' && openEndedQuestionsToShow.length > 0"
    >
      <div
        class="b-2"
        *ngFor="let question of openEndedQuestionsToShow; let i = index"
      >
        <div class="" *ngIf="!scoreHideQuestions.includes(question.type)">
          <div class="d-flex column label-score">
            <span class="ans-color mt-4">
              {{ "Score" | translator }}</span
            >
          </div>
          <p-inputNumber
            inputId="integeronly"
            class="input-number-field"
            [placeholder]="'Score' | translator"
            [inputStyle]="{
                'background-color': 'transparent',
                'border-radius': '8px',
                'width': '100%',
                'margin-right': '40px',
                'margin-top': '2px',
            }"
            [(ngModel)]="question.score"
            [min]="0" [max]="question.meta.marks"
          />
        </div>
        <div
          *ngIf="
            !scoreHideQuestions.includes(question.type) &&
            question.meta.feedback != undefined &&
            question.meta.feedback.trim() != ''
          "
          class="d-flex column label-score mb-2"
        >
          <span class="ans-color mt-4">{{
            "Feedback" | translator
          }}</span>
        </div>
        <p-editor
          [readonly]="true"
          *ngIf="
            !scoreHideQuestions.includes(question.type) &&
            question.meta.feedback != undefined &&
            question.meta.feedback.trim() != ''
          "
          [(ngModel)]="question.meta.feedback"
          class="w-100"
          [style]="{ height: '100px' }"
        ></p-editor>
        <app-question-template
          [disabled]="true"
          [question]="question"
          #questionDiv
        ></app-question-template>
      </div>
    </p-tabPanel>
  </p-tabView>
  <div align="center">
    <button
      *ngIf="from == 'assessment'"
      class="v4-btn-every"
      (click)="openQuestionModal = false; updateResults()"
    >
      <i class="pi pi-check"></i>{{ "Save" | translator }}
    </button>
  </div>
</p-dialog>
